import { observer, useLocalObservable } from 'mobx-react-lite'
import React, { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { toastError } from '../../components/FormComponents/Toasts'
import axiosService from '../../utils/AxiosService'

export const SharedClientContext = React.createContext({})

export default observer(function SharedClientProvider(props) {
  const { id } = useParams()
  const navigate = useNavigate()

  const state = useLocalObservable(() => ({
    isLoading: true,
    client: null,
    campaigns: [],
    calendarEvents: [],
  }))

  const fetchCalendarEvents = () =>
    axiosService.get('/api/advertiser/client_share/calendar_events')
      .then(events => { state.calendarEvents = events })
      .catch(() => {})

  useEffect(() => {
    state.isLoading = true
    Promise.all([
      axiosService.get('/api/advertiser/client_share/client')
        .then(client => { state.client = client })
        .catch(({ data: { error } }) => {
          toastError(error)
          navigate('/advertiser/share_expired')
        }),
      axiosService.get('/api/advertiser/client_share/campaigns')
        .then(campaigns => { state.campaigns = campaigns })
        .catch(({ data: { error } }) => toastError(error || 'Failed to load campaigns')),
      fetchCalendarEvents(),
    ]).finally(() => { state.isLoading = false })
  }, [id])

  return (
    <SharedClientContext.Provider
      value={{
        client: state.client,
        campaigns: state.campaigns,
        calendarEvents: state.calendarEvents,
        isLoading: state.isLoading,
        refetchCalendarEvents: fetchCalendarEvents,
      }}
    >
      {props.children}
    </SharedClientContext.Provider>
  )
})
